export default {"src":"/_next/static/media/personal-relations.55cf03a8.svg","height":400,"width":400,"blurWidth":0,"blurHeight":0};